import React, { createElement } from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Features } from '../components/Features';
import { Helmet } from 'react-helmet-async';
export function AboutPage() {
  return <>
      <Helmet data-id="element-131">
        <title data-id="element-132">About Us - Fifth Door</title>
        <meta name="description" content="Empower anyone to create games without coding." data-id="element-133" />
        <link rel="preconnect" href="https://fonts.googleapis.com" data-id="element-134" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" data-id="element-135" />
        <link href="https://fonts.googleapis.com/css2?family=Bungee&family=Bricolage+Grotesque:wght@400;500;600;700&family=Instrument+Sans:wght@400;500;600;700&display=swap" rel="stylesheet" data-id="element-136" />
        <script data-id="element-137">
          {`
            !function(t,e){var o,n,p,r;e.__SV||(window.posthog && window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="init yi Fr Mr mi Rr Or capture Li calculateEventProperties Dr register register_once register_for_session unregister unregister_for_session zr getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey displaySurvey canRenderSurvey canRenderSurveyAsync identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty Nr jr createPersonProfile Ur Tr Hr opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing get_explicit_consent_status is_capturing clear_opt_in_out_capturing Ar debug L Lr getPageViewId captureTraceFeedback captureTraceMetric $r".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
            posthog.init('phc_jETIRcaQQ5wwKvb9mxnRwHnNeXlgXBbTtVWc0NYToYa', {
              api_host: 'https://us.i.posthog.com',
              defaults: '2025-05-24',
              person_profiles: 'identified_only'
            })
          `}
        </script>
      </Helmet>

      <main className="w-full relative isolate overflow-x-hidden min-h-screen" style={{
      backgroundColor: '#074030'
    }} data-id="element-138">
        {/* Background Effects */}
        <div className="absolute inset-0 pointer-events-none -z-10" style={{
        backgroundImage: `
              linear-gradient(to right, rgba(255, 255, 255, 0.1) 1px, transparent 1px),
              linear-gradient(to bottom, rgba(255, 255, 255, 0.1) 1px, transparent 1px)
            `,
        backgroundSize: '30px 30px',
        backgroundPosition: '0 0'
      }} data-id="element-139" />

        <div className="absolute inset-0 pointer-events-none -z-10" style={{
        backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/bonQpX7FQKEhKvnQfRNJtT/noise-background.png)',
        backgroundRepeat: 'repeat',
        backgroundSize: '200px 200px',
        opacity: 0.24
      }} data-id="element-140" />

        {/* Logo - Top Left Absolute Position */}
        <div className="absolute top-8 left-8 z-20" data-id="element-141">
          <Link to="/" className="flex items-center gap-3" data-id="element-142">
            <img src="https://cdn.magicpatterns.com/uploads/8dB8M4GqHB66FgPhzt2tyW/Group_44.png" alt="Fifth Door Logo" className="h-8 w-auto object-contain brightness-0 invert" data-id="element-143" />
            <span className="text-white text-lg" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-144">
              FIFTH DOOR
            </span>
          </Link>
        </div>

        {/* Content */}
        <div className="relative z-10 px-6 py-20 md:py-32 max-w-4xl mx-auto text-center" data-id="element-145">
          <div className="flex justify-center mb-8" data-id="element-146">
            <div className="inline-flex items-center px-8 md:px-10 py-2 rounded-full" style={{
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(4px)'
          }} data-id="element-147">
              <p className="text-sm font-normal" style={{
              color: 'rgba(255, 255, 255, 0.5)',
              fontFamily: "'Instrument Sans', sans-serif"
            }} data-id="element-148">
                Creativity begins when people are free to build. Anyone can
                create when they're given the tools to do so.
              </p>
            </div>
          </div>
          <p className="text-[50px] md:text-[74px] mb-4" style={{
          fontFamily: 'Bungee, sans-serif',
          color: 'white',
          lineHeight: '1.1'
        }} data-id="element-149">
            OUR MISSION
          </p>
          <p className="text-xl md:text-2xl leading-relaxed mb-16 text-white/80" style={{
          fontFamily: "'Instrument Sans', sans-serif"
        }} data-id="element-150">
            Fifth Door unlocks the power of imagination by making it easy for
            you to create, share, and play turn-based games anywhere, with
            anyone. We exist to stimulate the creativity, connection, and joy
            that people get when they play games.
          </p>
        </div>
        <Features data-id="element-151" />
      </main>
      <Footer data-id="element-152" />
    </>;
}